"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = __importStar(require("yup"));
var i18n_1 = __importDefault(require("../i18n"));
var PASSWORD_VALIDATION = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
var settingsSchema = function (skipPassword, isDeveloper) {
    var validationRules = {
        username: Yup.string().required(i18n_1.default.t('common:ERROR_MESSAGES.NAME_IS_REQUIRED')),
        developerName: Yup.string().when('isDeveloper', {
            is: true,
            then: Yup.string().required(i18n_1.default.t('common:ERROR_MESSAGES.COMPANY_NAME_IS_REQUIRED')),
        }),
        website: Yup.string()
            .nullable()
            .website(i18n_1.default.t('common:ERROR_MESSAGES.INVALID_URL')),
        contacts: Yup.array()
            .of(Yup.object().shape({
            phone: Yup.string().armPhone(i18n_1.default.t('common:ERROR_MESSAGES.INVALID_ARM_PHONE')),
        }))
            .unique(i18n_1.default.t('common:ERROR_MESSAGES.DUPLICATE_PHONE'), 'contacts', 'phone'),
    };
    if (!skipPassword) {
        validationRules.oldPassword = Yup.string()
            .required(i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_IS_REQUIRED'))
            .matches(PASSWORD_VALIDATION, i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_NOT_VALID'));
        validationRules.password = Yup.string()
            .required(i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_IS_REQUIRED'))
            .matches(PASSWORD_VALIDATION, i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_NOT_VALID'));
        validationRules.passwordConfirmation = Yup.string()
            .required(i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_IS_REQUIRED'))
            .matches(PASSWORD_VALIDATION, i18n_1.default.t('common:ERROR_MESSAGES.PASSWORD_NOT_VALID'))
            .oneOf([Yup.ref('password')], i18n_1.default.t('common:ERROR_MESSAGES.PASSWORDS_SHOULD_MATCH'));
    }
    if (isDeveloper) {
        validationRules.dateOfEstablishment = Yup.string().nullable();
        validationRules.developerMedia = Yup.array().nullable();
    }
    return Yup.object(validationRules);
};
exports.default = settingsSchema;
